module.exports = __webpack_public_path__ + "static/media/bb_logo.8d4f9a50.jpeg";